module.exports = __webpack_public_path__ + "public/Icons/exportDark.png?019f5355";